import { QuestionType, QuestionTypeApi } from '@stormwater-software/lib-inspection-templates';
import xhrService from '../api';
import { getOfflineQuestionTypes } from '../../db/db';
import { withOfflineFallback } from '../offlineFallback';
import { apiError } from '../apiError';

export interface NewQuestionType {
  label: string;
  controlTypes: string[];
  isSystem?: boolean;
}

export const questionTypeApi: QuestionTypeApi & {
  create: (data: NewQuestionType) => Promise<QuestionType>;
} = {
  index: () =>
    // The inspection details layout gates rendering on this having resolved, so
    // offline it must come from the copy cached with the downloaded template.
    withOfflineFallback(
      () =>
        xhrService
          .get(`/api/question-types`)
          .then((res) => res.data)
          .catch((error) => {
            // `response` is absent on network-level failures; destructuring it
            // here replaced the real error with a TypeError.
            throw new Error(error?.response?.data?.message || error.message);
          }),
      getOfflineQuestionTypes,
    ),

  create: (data) => {
    return xhrService
      .post(`/api/question-types`, data)
      .then((res) => res.data)
      .catch((err) => {
        throw apiError(err);
      });
  },
};
